export const state = {
  current: null,
}

export const getters = {}

export const mutations = {
  SET_CURRENT(state, breakpoint) {
    state.current = breakpoint
  },
}

export const actions = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
